import { ReportRowComponent } from '../report-row/report-row.component';
import { Component, OnInit, DoCheck, ElementRef, ViewChild, ViewContainerRef, ComponentFactoryResolver, ComponentFactory, ComponentRef, OnDestroy, Input, HostBinding } from '@angular/core';

@Component({
  selector: 'app-report-renderer',
  templateUrl: './report-renderer.component.html',
  styleUrls: ['./report-renderer.component.css']
})
export class ReportRendererComponent implements OnInit, DoCheck {

  @ViewChild('reportContainer', { read: ViewContainerRef }) reportContainer;
  private componentRefs: ComponentRef<any>[];
  public _ReportData: Array<any>;
  private _HeaderData: Array<any>;
  @Input() HasHeader: boolean;
  @Input() reportService: string;

  @ViewChild('tableHeader') headerTable!: ElementRef;
  @ViewChild('tableBody') bodyTable!: ElementRef;
  @ViewChild('containerHeader') containerHeader!: ElementRef;
  @ViewChild('containerBody') containerBody!: ElementRef;

  headerHeight = '0px';
  
  constructor(private resolver: ComponentFactoryResolver) {

  }
  @Input('ReportData')
  set records(val: any[]) {
    if(this.HasHeader) {
      this._HeaderData = val[0];
      this._ReportData = val.slice(1);
    } else {
      this._ReportData = val;
    }
  }
  
  ngDoCheck() {
	  if (this.HasHeader && this.headerTable) {
	  	this.headerHeight = this.headerTable.nativeElement.offsetHeight + 'px';
	  } else {
		  this.headerHeight = '0px';
	  }
  }

  ngOnInit() {
	  
  }

  getCellClass(value:object, index:number): string {
    let cellClass = 'ui-g-1';
    if(value['width'] === 'auto') {
      if(value['label'].length > 10) {
        cellClass = 'ui-g-2';
      } else if(value['label'].length > 20) {
        cellClass = 'ui-g-3';
      } else if(value['label'].length > 30) {
        cellClass = 'ui-g-4';
      } else if(value['label'].length > 40) {
        cellClass = 'ui-g-5';
      } else if(value['label'].length > 50) {
        cellClass = 'ui-g-6';
      } else {
        cellClass = 'ui-g-1';
      }
    } else {
      cellClass = ' ' + value['width'];
    }
    if(value['classList'] != null && value['classList'].length !== 0) {
      cellClass += ' ' + value['classList'];
    }
    if(cellClass.indexOf('header-row') === -1) {
//      if(index%2 === 1) {
//        cellClass += ' odd-row';
//      } else {
//        cellClass += ' even-row';
//      }
    }
    return cellClass;
  }
  onScroll(): void {
	  try {
	  	this.containerHeader.nativeElement.scrollLeft = this.containerBody.nativeElement.scrollLeft;
	  } catch {}
  }
  getHeaderHeight(): string {
	  return this.HasHeader ? this.headerHeight : '0px';
  }

  get bodyHeight(): string {
	  return `calc(100vh - ${this.getHeaderHeight()} - 260px)`;
  }

  get enableHorizontalScroll(): boolean {
    return this.reportService === 'client-request-list'
      || this.reportService === 'client-request-details'
      || this.reportService === 'member-analysis';
  }

  @HostBinding('class')
  get hostClasses(): string {
    const classes: string[] = [];
    if (this.enableHorizontalScroll) {
      classes.push('report-hscroll-host');
    }
    if (this.reportService === 'client-request-list') {
      classes.push('report-layout-list');
    }
    if (this.reportService === 'client-request-details') {
      classes.push('report-layout-details');
    }
    if (this.reportService === 'member-analysis') {
      classes.push('report-layout-member-analysis');
    }
    if (!this.HasHeader) {
      classes.push('report-no-header');
    }
    return classes.join(' ');
  }
}
